module.exports = __webpack_public_path__ + "50fbcdca478d8d5a44c160e6eb305c20.png";